export const MENUS = {
  summary: {id: 'summary', title: 'Gesamtvermögen'},
  assets: {id: 'assets', title: 'Vermögenswerte'},
  liabilities: {id: 'liabilities', title: 'Verbindlichkeiten'},
};